<template>
  <div class="btn-down" style="opacity: 1;">
    <div class="animate-mouse">
      <img src="~images/scroll-down-icon.svg" alt="">
      <img src="~images/scroll-down-icon-dot.svg" alt="" class="mover">
    </div>
    <span>Scroll down</span>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">
.btn-down {
  text-align: center;
  transition: opacity 0.5s;

  & > * {
    display: block;
    margin: 0 auto;
  }

  .animate-mouse {
    width: 20px;
    height: 32px;
    position: relative;

    & > * {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }

  span {
    text-transform: uppercase;
    font-size: 11px;
    font-family: $font-CuratorRegular;
    white-space: nowrap;
    opacity: 0.6;
  }

  .mover {
    animation: scrollDown 2s ease infinite;
    left: 0;
  }
}

@keyframes scrollDown {
  0% {
    transform: translateY(-10px);
    opacity: 0.5;
  }

  50% {
    transform: translateY(0);
    opacity: 1;
  }

  100% {
    transform: translateY(-10px);
    opacity: 0.5;
  }
}
</style>
